export default __webpack_public_path__ + "static/media/wallet_icon.cfe8a67f.svg";